module.exports = "https://img.zhijierongxing.com/saas/img/mark_bs.fa807322.png";